module.exports = __webpack_public_path__ + "0dc4b0f397e4e83a5b6129ee0c87cc6e.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/head/wasistgoldencity.jpg
// module id = 501
// module chunks = 0